export default __webpack_public_path__ + "static/media/army.c603ad30.webp";